<!--
   V 0.2.0 - 2024-10-02
      - made raptor eye image clickable so that I could set the internal debug
        variable

   V 0.1.0 - 2023-04-03
      - Added ability to see all sub clients that are part of a group.

-->
<template>
  <div>
    <v-card>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card class="mx-auto" outlined>
              <div class="list-group-item list-group-item-home">
                <h1 class="ng-binding" style="text-align: center">
                  Raptor Mobile
                  <small></small>
                </h1>

                <v-row>
                  <v-col> </v-col>
                  <v-col> </v-col>
                  <v-col> </v-col>
                  <v-col class="text-center">
                    <v-img :src="`${$staticBaseUrl}/img/Raptor Eye.png`"
                           max-width="300"
                           @click="incrementCounter"
                           class="clickable-image" />
                  </v-col>
                  <v-col> </v-col>
                  <v-col> </v-col>
                  <v-col> </v-col>
                </v-row>

                <div>
                  <div style="text-align: center">
                    Emergency: Theft or Hijacking
                  </div>
                  <div style="text-align: center">
                    <a href="tel:+27-800-014-525">0800 014 525</a>
                    <!--  <a href="tel:+27-860-106-231">0860 106 231 (PRIMARY)</a>  -->
                  </div>
                  <br />

                  <div style="text-align: center">
                    <a href="tel:+27-11-805-0050">011 805 0050 </a>
                    <!--  <a href="tel:+27-860-106-231">0860 106 231 (PRIMARY)</a>  -->
                  </div>
                </div>
              </div>

              <v-card-actions>
                <!--
                                                        <v-btn text>Button</v-btn>
                                                        <v-btn text>Button</v-btn>
                                -->
              </v-card-actions>
            </v-card>

            <v-card>
              <v-card-title primary-title class="justify-center">
                <div sm12>Client Details:</div>
              </v-card-title>
            </v-card>

            <v-card class="mx-auto"
                    v-for="(client_details, index) in clientList"
                    :key="index">
              <v-card-title primary-title class="justify-center">
                <span sm12 class="fa-stack fa-lg">
                  <i class="fa fa-circle-thin fa-stack-2x"
                     style="color: #2196f3"></i>
                  <i class="fa fa-user fa-stack-1x" style="color: #2196f3"></i>
                </span>
              </v-card-title>

              <div>
                <div style="text-align: center">
                  <div>
                    <b>Name:</b>
                    {{ client_details.Title }}
                    {{ client_details.Initials }} {{ client_details.FName }}
                    {{ client_details.LName }}
                  </div>

                  <div>
                    <b>Land line:</b>
                    {{ client_details.Tel_Code }}
                    {{ client_details.Tel_No }}
                  </div>

                  <div>
                    <b>Mobile:</b>
                    {{ client_details.CellNo }}
                  </div>

                  <div>
                    <b>Email:</b>
                    {{ client_details.EMailAddress }}
                  </div>
                </div>

                <v-spacer></v-spacer>
              </div>

              <!-- --END OF LIST-->
            </v-card>

            <v-spacer></v-spacer>

            <v-card v-if="debugMode">
              <v-card-title primary-title class="justify-center">
                <div sm12>Debug Mode:</div>
                {{ clickCount }}
              </v-card-title>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      debugMode: this.$debug,

      clickCount: 0,
      item: 1,
      errors: [],
      vehicles: [],
      assets: [],
      // client_details: [],
      clientList: {}
    }
  },

  mounted () {
    console.log(`$isLoggedIn: ${this.$store.state.isLoggedIn}`)
    console.log(`$debug: ${this.$store.state.debug}`)
  },

  methods: {
    incrementCounter () {
      this.clickCount++
      if (this.clickCount >= 5) {
        this.$debug = !this.$debug
        this.debugMode = this.$debug
        this.$store.commit('setDebug', this.$debug)

        this.clickCount = 0
      }
    }
  },

  /**
     *   V 0.1.0 - 2023-04-03
     *     - removed header setting and changed to v2 controlers
     *
     *  */
  created () {
    var url = this.$baseUrl + '/api/v2/client'

    var token = this.$store.state.token

    if (this.$debug) {
      console.log(url)
    }

    this.$axios
      .get(url)
      .then((response) => {
        if (this.$debug) {
          console.log(response.data)
        }

        this.clientList = response.data
      })
      .catch((e) => {
        this.errors.push(e)
      })
  }
}
</script>

<style scoped>
  .clickable-image {
    cursor: pointer;
    border-radius: 10px;
    overflow: hidden;
    transition: transform 0.2s;
  }

    .clickable-image:hover {
      transform: scale(1.05);
    }
</style>
